import { Line, mixins } from 'vue-chartjs';

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  name: 'ChartNamibiaTrainersActivity',
  props: {
    chartData: Object,
    options: Object,
    styles: Object,
  },
  mounted() {
    this.renderChart(this.chartData, this.chartData.options);
  },
};
